<template>
  <Transition
    class="fixed bottom-4 left-0 right-0 flex justify-between min-w-[300px] max-w-[500px] gap-6 items-center px-6 py-3 m-auto border border-neutral-300 rounded-md text-neutral-300 bg-[#111111] z-[9999999999]"
    enter-active-class="duration-300 ease-out"
    enter-from-class="transform opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="transform opacity-0 translate-y-4"
  >
    <div v-show="meta.dirty">
      <span>{{ message }}</span>
      <div class="flex gap-3">
        <Button
          variant="ghost"
          type="button"
          size="sm"
          :disabled="isPending"
          @click="resetForm"
        >
          Reset
        </Button>
        <Button
          size="sm"
          :disabled="isPending || !meta.dirty"
          :form="formId"
          :loading="isPending"
        >
          Save
        </Button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { Button } from '@ui/components/button';

defineProps({
  formId: {
    type: String,
    default: null,
  },
  isPending: {
    type: Boolean,
    required: true,
  },
  meta: {
    type: Object,
    required: true,
  },
  resetForm: {
    type: Function,
    required: true,
  },
  message: {
    type: String,
    default: 'You have unsaved changes!',
  },
});
</script>
